import { render, staticRenderFns } from "./3rdRamListPop.vue?vue&type=template&id=93c7929c"
import script from "./3rdRamListPop.vue?vue&type=script&lang=js"
export * from "./3rdRamListPop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('93c7929c')) {
      api.createRecord('93c7929c', component.options)
    } else {
      api.reload('93c7929c', component.options)
    }
    module.hot.accept("./3rdRamListPop.vue?vue&type=template&id=93c7929c", function () {
      api.rerender('93c7929c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/ram/riskRegister/3rdRamListPop.vue"
export default component.exports